import { EThemeDefaultDialogCanvas } from "./e-theme-default-dialog-canvas";

export class EThemeDefaultJaJpDialogCanvas extends EThemeDefaultDialogCanvas {}
